module.exports = "/_next/static/resources/ingredients-db912bee3797b9193362e9d22bb06b81.webp";